import { render, staticRenderFns } from "./newTransWarehouseEdit_v2.vue?vue&type=template&id=52dc0340&scoped=true&"
import script from "./newTransWarehouseEdit_v2.vue?vue&type=script&lang=js&"
export * from "./newTransWarehouseEdit_v2.vue?vue&type=script&lang=js&"
import style0 from "./newTransWarehouseEdit_v2.vue?vue&type=style&index=0&id=52dc0340&lang=less&scoped=true&"
import style1 from "./newTransWarehouseEdit_v2.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dc0340",
  null
  
)

component.options.__file = "newTransWarehouseEdit_v2.vue"
export default component.exports